module.exports = "<!-- <p>\n  my-charts works!\n</p> -->\n\n\n<div [id]=\"id\" [class]=\"classes\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/my-charts/my-charts.component.html
// module id = ./src/app/components/my-charts/my-charts.component.html
// module chunks = main